import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

export function BarChartCard(props: {
  title: string;
  data: any[];
  xKey: string;
  barKey: string;
}) {
  const data = Array.isArray(props.data) ? props.data : [];
  const hasData = data.length > 0;

  return (
    <div className="card machines-section-card shadow-sm h-100">
      <div className="card-header fw-semibold">{props.title}</div>
      <div className="card-body" style={{ width: "100%", minHeight: 280, height: 320 }}>
        {hasData ? (
          <ResponsiveContainer width="100%" height={280} minHeight={200}>
            <BarChart data={data}>
            <XAxis dataKey={props.xKey} />
            <YAxis />
            <Tooltip />
            <Bar dataKey={props.barKey} />
          </BarChart>
        </ResponsiveContainer>
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100 text-muted small">
            Nessun dato energia disponibile
          </div>
        )}
      </div>
    </div>
  );
}